import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { UnitDictionary } from "pages/InventoryAndSales/Inventory/BaseDefinitionAndSetting/Unit/components/UnitDictionary";
import { useEffect, useState } from "react";
import { GUID_EMPTY, ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";

import { uuidv4 } from "utils/helpers";
import { getSellectableWarehouseItemDetail } from "../SellectableWarehouseItem/api";
import { SellectableWarehouseItem } from "../SellectableWarehouseItem/SellectableWarehouseItem";

import { CheckableButton } from "components/CheckableButton/CheckableButton";
import Datepicker from "components/DatePicker/DatePicker";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { Loading } from "components/Loading/loading";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { PriceInput } from "../../../../../../components/PriceInput/PriceInput";


interface SalesInvoiceFormProps {
  onHide: () => void;
  warehouseIODetail?: any;
  mode: any;
  warehouseId: any;
  selectedObj?: any;
  WarehouseDetailId?: any;
  WarehouseDetail?: any;
  WarehouseDetailsCount?: any;
  jobId?: any;
}

export const InventoryReceiptDetailForm = ({
  mode,
  onHide,
  warehouseIODetail,
  warehouseId,
  selectedObj,
  WarehouseDetailId,
  WarehouseDetail,
  WarehouseDetailsCount,
  jobId,
}: SalesInvoiceFormProps) => {
  const [showTree, setShowTree] = useState<any>();
  const [userChanges, setUserChanges] = useState({});
  const [loading, setLoading] = useState<any>(true);
  const [itemSearch, setItemSearch] = useState<any>("");

  const [warehouseData, setWarehouseData] = useState<any>({
    WarehouseId: warehouseId,
    WarehouseDetailId,
  });
  const [expireDate, setExpireDate] = useState<any>(null);
  const [itemData, setItemData] = useState<any>();

  const [dictionaryNameUnit, setDictionaryNameUnit] = useState<any>({});
  const [detailWarehouseData, setDetailWarehouseData] = useState<any>({
    QtyIn2: 0,
    QtyIn1: 1,
    ItemValue: 0,
    // ItemValueIn: 0,
    // WageCost: 0,
    DeliveryCost: 0,
    UnitPrice:0
  });
  const [resetForm, setResetForm] = useState(false);

  const itemCodeHandeler = (obj) => {
    setLoading(false);
    setItemData({
      Code: obj.ItemCode,
      Id: obj.Id,
      ItemDescription: obj.ItemDescription,
      TechnicalCode: obj.ItemTechnicalCode,
      ItemStockList: obj.ItemStockList,
      HasProductTracking: obj.HasProductTracking,
      HasExpireDate: obj.HasExpireDate,
    });
    setDetailWarehouseData({
      ...obj,
      UnitIn1Id: obj.MainUnitId,
      UnitIn2Id: obj.StatisticalUnitId,
      UnitIn2: obj.Unit2,
      UnitIn1: obj.Unit1,
      QtyIn1: obj.QtyMainUnit?obj.QtyMainUnit:1,
      QtyIn2: obj.QtyStatisticalUnit,
      ItemValue: 0,
      ItemValueIn: 0,
      // WageCost: 0,
      DeliveryCost: 0,
      UnitPrice:0
    });
    setResetForm(true);
    setDictionaryNameUnit({ UnitIn2: obj.Unit2, UnitIn1: obj.Unit1 });
    setShowTree(false);
    setLoading(true);
  };


  const calculateItemValue=(e)=>{
    if((!detailWarehouseData?.QtyIn1 && detailWarehouseData?.UnitPrice) || (detailWarehouseData?.QtyIn1 && !detailWarehouseData?.UnitPrice) ){
if(!detailWarehouseData?.QtyIn1){

  setDetailWarehouseData({
                        ...detailWarehouseData,
                        ItemValue: +(e.target.value?.replaceAll(',','')),
                        ItemValueIn:
                          +(e.target.value?.replaceAll(',','')) +
                          // detailWarehouseData.WageCost +
                          detailWarehouseData.DeliveryCost,
                          QtyIn1:+(e.target.value?.replaceAll(',',''))/detailWarehouseData?.UnitPrice
                         
                      });


}else{
  setDetailWarehouseData({
                        ...detailWarehouseData,
                        ItemValue: +(e.target.value?.replaceAll(',','')),
                        ItemValueIn:
                          +(e.target.value?.replaceAll(',','')) +
                          // detailWarehouseData.WageCost +
                          detailWarehouseData.DeliveryCost,
                          UnitPrice:+(e.target.value?.replaceAll(',',''))/detailWarehouseData?.QtyIn1
                         
                         
                      });
}








    }else{

  setDetailWarehouseData({
                        ...detailWarehouseData,
                        ItemValue: +(e.target.value?.replaceAll(',','')),
                        ItemValueIn:
                          +(e.target.value?.replaceAll(',','')) +
                          // detailWarehouseData.WageCost +
                          detailWarehouseData.DeliveryCost,
                          UnitPrice:+(e.target.value?.replaceAll(',',''))/detailWarehouseData?.QtyIn1
                         
                         
                      });

    }

      

  }

  const handleSubmit = (event) => {
    event.preventDefault();
    let data = {
      Id: mode != "create" ? selectedObj?.Id : uuidv4(),
      ItemId: itemData?.Id,
      ItemCode: itemData?.Code,
      SourceId:
        itemData?.Id == selectedObj?.ItemId
          ? selectedObj?.SourceId != GUID_EMPTY && selectedObj?.SourceId
            ? selectedObj?.SourceId
            : null
          : null,
      SourceData:
        itemData?.Id == selectedObj?.ItemId
          ? selectedObj?.SourceData
            ? selectedObj?.SourceData
            : null
          : null,
      Item: itemData?.ItemDescription,
      ItemTechnicalCode: itemData?.ItemTechnicalCode,
      HasProductTracking: itemData?.HasProductTracking,
      WarehouseDetail: warehouseData?.WarehouseDetail,
      WarehouseDetailId: warehouseData?.WarehouseDetailId,
      HasExpireDate: itemData?.HasExpireDate,
      UnitPrice:+(event.target.UnitPrice?.value?.replaceAll(',','')),
      ExpireDate: itemData?.HasExpireDate ? expireDate : null,
      PartyNo: itemData?.HasProductTracking
        ? event.target?.PartyNo?.value
        : null,
      UnitIn1Id: event.target.UnitIn1Id?.value,
      UnitIn1: dictionaryNameUnit.UnitIn1,
      UnitIn2Id: event.target.UnitIn2Id?.value
        ? event.target.UnitIn2Id?.value
        : null,
      UnitIn2: dictionaryNameUnit.UnitIn2,
      QtyIn1: +event.target.QtyIn1?.value,
      QtyIn2: +event.target.QtyIn2?.value,
      ItemValue: event.target.ItemValue?.value
        ? +(event.target.ItemValue?.value?.replaceAll(',',''))
        : 0,
      ItemValueIn: event.target.ItemValueIn?.value
        ? +(event.target.ItemValueIn?.value?.replaceAll(',',''))
        : 0,
      WageCost:
      //  event.target.WageCost?.value
      //   ? +(event.target.WageCost?.value?.replaceAll(',',''))
      //   :
         0,
      Description: event.target.Description?.value,
      DescriptionEN: event.target.DescriptionEN?.value,
      QCNo: event.target.QCNo?.value,
      QtySource: 0,
      DeliveryCost: event.target.DeliveryCost?.value
        ? +(event.target.DeliveryCost?.value?.replaceAll(',',''))
        : 0,
      // OtherCost: 0,
      // OverloadCost: 0,
      // UnitIn1Id: event.target.UnitIn1Id?.value,
      // UnitIn1:dictionaryNameUnit.UnitIn1,
      // UnitIn2Id: event.target.UnitIn2Id?.value,
      // UnitIn2:dictionaryNameUnit.UnitIn2,
      Calculated: event.target.Calculated?.checked,
      CalculatedBySystem: event.target.CalculatedBySystem?.checked,
      // CalculatedByAlteration: event.target.CalculatedByAlteration?.checked,
      ManualRegistered: event.target.PriceRegistered?.checked,
      // QtyIn1: +event.target.QtyIn1?.value,
      // QtyIn2: +event.target.QtyIn2?.value,
      // ItemValueIn: +event.target.ItemValueIn?.value,


      ItemEN: null,

      WarehouseDetailEN: null,
      UnitIn1EN: null,
      UnitIn2EN: null,

      HasSerial: false,

      IsSerialObligatory: false,
      ReturnableQty: null,
    };

    warehouseIODetail?.(data);
    onHide && onHide();
  };

  const getItemDetailAsync = async (id = null, e = null) => {
    setLoading(false);
    try {
      const res = await getSellectableWarehouseItemDetail(
        id,
        warehouseData?.WarehouseId,
        warehouseData?.WarehouseDetailId,
        true,
        e
      );
      setItemData({
        Code: res.Data.ItemCode,
        Id: res.Data.Id,
        ItemDescription: res.Data.ItemDescription,
        TechnicalCode: res.Data.ItemTechnicalCode,
        ItemStockList: res.Data.ItemStockList,
        HasProductTracking: res.Data.HasProductTracking,
        HasExpireDate: res.Data.HasExpireDate,
      });
      //when onblur event is run, we should set DetailWarehouseData
      setDetailWarehouseData({
        ...res.Data,
        UnitIn1Id: res.Data.MainUnitId,
        UnitIn2Id: res.Data.StatisticalUnitId,
        UnitIn2: res.Data.Unit2,
        UnitIn1: res.Data.Unit1,
        QtyIn1: res.Data.QtyMainUnit?res.Data.QtyMainUnit:1,
        QtyIn2: res.Data.QtyStatisticalUnit,
        ItemValue: 0,
        ItemValueIn: 0,
        // WageCost: 0,
        PartyNo: null,
        ExpireDate: null,
        UnitPrice:0
      });
      setDictionaryNameUnit({
        UnitIn2: res.Data.Unit2,
        UnitIn1: res.Data.Unit1,
      });

      //setDetailWarehouseData({ ...selectedObj,ItemDescription:selectedObj?.Item });
    } catch (error) {
      setShowTree(true);
      setItemSearch(e);
    }
    setLoading(true);
  };

  const updateQuantity = async (newQty, QtyInChange) => {
    setDetailWarehouseData({
      ...detailWarehouseData,
      QtyIn1:
        QtyInChange == "QtyIn1"
          ? newQty
          : newQty / detailWarehouseData.ConversionRatio,
      QtyIn2:
        QtyInChange == "QtyIn2"
          ? newQty
          : newQty * detailWarehouseData.ConversionRatio,

...(detailWarehouseData?.ItenValue?{UnitPrice:detailWarehouseData?.ItenValue/(QtyInChange == "QtyIn1"
          ? newQty
          : newQty / detailWarehouseData.ConversionRatio)}:null),

ItemValueIn:(+detailWarehouseData?.UnitPrice * +(  QtyInChange == "QtyIn1"
          ? newQty
          : newQty / detailWarehouseData.ConversionRatio) )+
                          // +detailWarehouseData.WageCost +
                          +detailWarehouseData.DeliveryCost,

    });
  };

  const initializeFormWithSelectedObject = () => {
    setItemData({
      Code: selectedObj?.ItemCode,
      Id: selectedObj?.ItemId,
      ItemDescription: selectedObj?.Item,
      TechnicalCode: selectedObj?.ItemTechnicalCode,
      ItemStockList: selectedObj?.ItemStockList,
      HasProductTracking: selectedObj?.HasProductTracking,
      HasExpireDate: selectedObj?.HasExpireDate,
    });

    setDetailWarehouseData({
      ...selectedObj,
      ItemDescription: selectedObj?.Item,
    });
  };

  useEffect(() => {
    if (mode !== "create") {
      initializeFormWithSelectedObject();
      //getItemDetailAsync(selectedObj?.ItemId);
    }
  }, []);

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]); 

  return (
    <>
      {loading ? (
        <div className="card " style={{ flexDirection: "row" }}>
          {showTree && (
            <ModalForm
              mode={mode}
              title="ItemTree"
              onHide={() => setShowTree(false)}
              show={showTree}
            >
              <SellectableWarehouseItem
                onHide={() => {
                  setShowTree(false);
                }}
                fetchItem={true}
                itemCodeHandeler={itemCodeHandeler}
                warehouseId={warehouseData?.WarehouseId}
                warehouseDetailId={warehouseData?.WarehouseDetailId}
                forItemInput={true}
                searchString={itemSearch}
              />
            </ModalForm>
          )}
          <div style={{ flexWrap: "nowrap" }} className="card-body row">
            <form action="" onSubmit={handleSubmit}>
              <div className="row">
                {((warehouseData?.WarehouseDetailId &&
                  warehouseData?.WarehouseDetailId != GUID_EMPTY) ||
                  (mode == "create" &&
                    !jobId &&
                    WarehouseDetailsCount > 0)) && (
                  <div className="col-lg-3">
                    <div className="">
                      <DictionarySelectBox
                        name="WarehouseDetail"
                        label="WarehouseDetail"
                        params={{ warehouseId: warehouseData?.WarehouseId }}
                        onChange={(e, obj) => {
                          setWarehouseData((prev) => {
                            return {
                              ...prev,
                              WarehouseDetailId: e,
                              WarehouseDetail: obj?.Name,
                            };
                          });
                        }}
                        valueString={
                          mode == "view" ? selectedObj?.WarehouseDetail : ""
                        }
                        baseUrl={INVENTORYANDSALES_URL}
                        endPoint={
                          ENDPOINTSINVENTORYANDSALES.Inventory
                            .BaseInformationApi.WarehouseDetail.dictionary
                        }
                        value={warehouseData?.WarehouseDetailId}
                        resetForm={resetForm}
                        mode={mode}
                      />
                    </div>
                  </div>
                )}
                <div
                  className="col-lg-3 col-sm-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <Textbox
                    required
                    onChange={(e) => {
                      if (e?.target.value === null || e?.target.value === "") {
                        setDetailWarehouseData({});
                        setItemData({});
                        setItemSearch("");
                      } else {
                        if (
                          // e.target.value != itemData?.Code &&
                          e.target.value.length > 2
                        )
                          if (isNaN(e.target.value)) {
                            setShowTree(true);
                          }
                        setItemSearch(e.target.value);
                      }
                    }}
                    onBlurHandler={(e) => {
                      if (e && e != itemData?.Code && !showTree) {
                        getItemDetailAsync(null, e);
                      }
                    }}
                    textboxName={"itemCode"}
                    textboxType="text"
                    labelText={"itemCode"}
                    mode={mode}
                    value={itemData?.Code}
                    defaultValue={itemData?.Code}
                  />
                  {mode != "view" && (
                    <div style={{ marginTop: "4px", width: "10%" }}>
                      <Button
                        Icon={true}
                        value={
                          <button
                            onClick={(e) => setShowTree(true)}
                            type="button"
                            className="checkButton d-flex align-items-center justify-content-center"
                          >
                            {" "}
                            <FontAwesomeIcon
                              icon={[ICON_TYPE, "diagram-project"]}
                              size="1x"
                            />
                          </button>
                        }
                        btnType="primary"
                        onClick={(e) => setShowTree(true)}
                      />
                    </div>
                  )}
                </div>
                {/* <div className="col-lg-3">
              <UnitDictionary
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                value={detailWarehouseData?.UnitIn1Id}
                label="UnitIn1Id"
                name="UnitIn1Id"
                required={false}
                // resetForm={resetForm}
                setUnitDictionary={(e) => {
                  setDictionaryName({ ...dictionaryName, UnitIn1: e.Value });
                }}
              />
            </div> */}
                {/* <div className="col-lg-3">
              <UnitDictionary
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                value={detailWarehouseData?.UnitIn2Id}
                label="UnitIn2Id"
                name="UnitIn2Id"
                required={false}
                // resetForm={resetForm}
                setUnitDictionary={(e) => {
                  setDictionaryName({ ...dictionaryName, UnitIn2: e.Value });
                }}
              />
            </div> */}

                {itemData && itemData?.ItemDescription && (
                  <div className="col-lg-4">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      withChangeDir={true}
                      textboxName="ItemDescription"
                      textboxType="text"
                      labelText="itemDescription"
                      value={itemData?.ItemDescription}
                      defaultValue={itemData?.ItemDescription}
                      resetForm={resetForm}
                      mode={"view"}
                      required={false}
                    />
                  </div>
                )}
                <div className="col-lg-3">
                  <UnitDictionary
                    returnObj
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    value={detailWarehouseData?.UnitIn1Id}
                    label="UnitIn1"
                    name="UnitIn1Id"
                    required={true}
                    resetForm={resetForm}
                    setUnitDictionary={(e) => {
                      setDictionaryNameUnit({
                        ...dictionaryNameUnit,
                        UnitIn1: e?.Value,
                      });
                    }}
                    mode={"view"}
                  />
                </div>
                <div className="col-lg-3">
                  <Textbox
                    required
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="QtyIn1"
                    textboxType="text"
                    labelText="QtyIn1"
                    value={
                      detailWarehouseData?.QtyIn1
                        ? detailWarehouseData?.QtyIn1
                        : null
                    }
                    defaultValue={
                      detailWarehouseData?.QtyIn1
                        ? detailWarehouseData?.QtyIn1 + ""
                        : null
                    }
                    mode={mode}
                    onChange={(e) => {
                      updateQuantity(+e.target.value, "QtyIn1");
                    }}
                    customValidation={(e) =>
                      +e <= 0 && {
                        invalid: true,
                        message: "Msg_ValueCannotBeZero",
                      }
                    }
                  />
                </div>

                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="QtyIn1"
                textboxType="text"
                labelText="QtyIn1"
                value={detailWarehouseData?.QtyIn1}
                defaultValue={detailWarehouseData?.QtyIn1}
              />
            </div> */}
                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="QtyIn2"
                textboxType="text"
                labelText="QtyIn2"
                value={detailWarehouseData?.QtyIn2}
                defaultValue={detailWarehouseData?.QtyIn2}
                mode={mode}

              />
            </div> */}
                {detailWarehouseData?.UnitIn2Id && (
                  <>
                    <div className="col-lg-3">
                      <UnitDictionary
                        returnObj
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        value={detailWarehouseData?.UnitIn2Id}
                        label="UnitIn2"
                        name="UnitIn2Id"
                        required={true}
                        resetForm={resetForm}
                        setUnitDictionary={(e) => {
                          setDictionaryNameUnit({
                            ...dictionaryNameUnit,
                            UnitIn2: e?.Value,
                          });
                        }}
                        mode={"view"}
                      />
                    </div>
                    <div className="col-lg-3">
                      <Textbox
                        required
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="QtyIn2"
                        textboxType="text"
                        labelText="QtyIn2"
                        value={
                          detailWarehouseData?.QtyIn2
                            ? detailWarehouseData?.QtyIn2
                            : null
                        }
                        defaultValue={
                          detailWarehouseData?.QtyIn2
                            ? detailWarehouseData?.QtyIn2 + ""
                            : null
                        }
                        customValidation={(e) =>
                          +e <= 0 && {
                            invalid: true,
                            message: "Msg_ValueCannotBeZero",
                          }
                        }
                        mode={mode}
                        onChange={(e) => {
                          updateQuantity(+e.target.value, "QtyIn2");
                        }}
                      />
                    </div>
                  </>
                )}
                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="QtySource"
                textboxType="text"
                labelText="QtySource"
                value={detailWarehouseData?.QtySource}
                defaultValue={detailWarehouseData?.QtySource}
              />
            </div> */}
                             <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="UnitPrice"
            
                    label="UnitPrice"
                    onChange={(e) => {
                      
                      setDetailWarehouseData({
                        ...detailWarehouseData,
                        UnitPrice: +(e.target.value?.replaceAll(',','')),
                        ItemValueIn:
                          (+(e.target.value?.replaceAll(',','')) * +detailWarehouseData.QtyIn1 ) +
                          // +detailWarehouseData.WageCost +
                          +detailWarehouseData.DeliveryCost,
...(detailWarehouseData?.ItenValue?{QtyIn1:detailWarehouseData?.ItenValue/+(e.target.value?.replaceAll(',',''))}:null),
                      });
                    }}
                    value={detailWarehouseData?.UnitPrice}
                    defaultValue={detailWarehouseData?.UnitPrice}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="ItemValue"
              
                    label="ItemValue"
                   onChange={(e)=>{
  calculateItemValue(e)

                   }}
                    value={detailWarehouseData?.UnitPrice * detailWarehouseData?.QtyIn1}
                    defaultValue={detailWarehouseData?.UnitPrice * detailWarehouseData?.QtyIn1}
                    mode={mode}
                  />
                </div>
               
                <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    mode={mode}
                    name="DeliveryCost"
                   
                    label="DeliveryCost"
                    onChange={(e) => {
                      // setTotalValueIn(totalValueIn + +e.target.value);
                      setDetailWarehouseData({
                        ...detailWarehouseData,
                        DeliveryCost: +(e.target.value?.replaceAll(',','')),
                        ItemValueIn:
                          +(e.target.value?.replaceAll(',','')) +
                          // detailWarehouseData.WageCost +
                          (detailWarehouseData?.UnitPrice * detailWarehouseData?.QtyIn1),
                      });
                    }}
                    value={detailWarehouseData?.DeliveryCost}
                    defaultValue={detailWarehouseData?.DeliveryCost}
                  />
                </div>
{/*   
                <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="WageCost"
              
                    label="WageCost"
                    onChange={(e) => {
                      setDetailWarehouseData({
                        ...detailWarehouseData,
                        WageCost: +(e.target.value?.replaceAll(',','')),
                        ItemValueIn:
                          +(e.target.value?.replaceAll(',','')) +
                          (detailWarehouseData?.UnitPrice * detailWarehouseData?.QtyIn1) +
                          detailWarehouseData.DeliveryCost,
                      });
                    }}
                    value={detailWarehouseData?.WageCost}
                    defaultValue={detailWarehouseData?.WageCost}
                    mode={mode}
                  />
                </div> */}
                <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="ItemValueIn"
                   
                    label="ItemValueIn"
                    value={detailWarehouseData?.ItemValueIn}
                    defaultValue={detailWarehouseData?.ItemValueIn}
                    mode={"view"}
                    
                    
                  />
                </div>

                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="OtherCost"
                textboxType="text"
                labelText="OtherCost"
                onChange={(e) => {
                  setTotalValueIn(totalValueIn + +e.target.value);
                }}
                value={detailWarehouseData?.OtherCost}
                defaultValue={detailWarehouseData?.OtherCost}
              />
            </div> */}
                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="OverloadCost"
                textboxType="text"
                labelText="OverloadCost"
                onChange={(e) => {
                  setTotalValueIn(totalValueIn + +e.target.value);
                }}
                value={detailWarehouseData?.OverloadCost}
                defaultValue={detailWarehouseData?.OverloadCost}
              />
            </div> */}

                <div className="col-lg-3">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="QCNo"
                    textboxType="text"
                    labelText="QCNo"
                    value={detailWarehouseData?.QCNo}
                    defaultValue={detailWarehouseData?.QCNo}
                    mode={mode}
                  />
                </div>

                {itemData?.HasProductTracking ? (
                  <div className="col-lg-3">
                    <Textbox
                      required
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="PartyNo"
                      textboxType="text"
                      labelText="PartyNo"
                      value={
                        detailWarehouseData?.PartyNo
                          ? detailWarehouseData?.PartyNo
                          : null
                      }
                      defaultValue={
                        detailWarehouseData?.PartyNo
                          ? detailWarehouseData?.PartyNo + ""
                          : null
                      }
                      mode={mode}
                    />
                  </div>
                ) : (
                  <></>
                )}
                {itemData?.HasExpireDate && loading ? (
                  <div className="col-lg-3">
                    <Datepicker
                      mode={mode}
                      lable="ExpireDate"
                      setIsoTime={(isoTime: string) => {
                        setExpireDate(isoTime);
                      }}
                      required={true}
                      val={
                        detailWarehouseData.ExpireDate
                          ? detailWarehouseData.ExpireDate
                          : null
                      }
                      errorFlag={false}
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                    />
                  </div>
                ) : (
                  <></>
                )}

                <div className="w-100"></div>
                <div className="row">
                  <div className="col-lg-6">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="Description"
                      textboxType="textarea"
                      labelText="Description"
                      value={detailWarehouseData?.Description}
                      defaultValue={detailWarehouseData?.Description}
                      mode={mode}
                    />
                  </div>
                  <div className="col-lg-6">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="DescriptionEN"
                      textboxType="textarea"
                      labelText="DescriptionEN"
                      value={detailWarehouseData?.DescriptionEN}
                      defaultValue={detailWarehouseData?.DescriptionEN}
                      mode={mode}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-3">
                  <CheckableButton
                    defaultChecked={detailWarehouseData?.Calculated}
                    defaultValue={detailWarehouseData?.Calculated}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    labelText={"Calculated"}
                    inputName={"Calculated"}
                    type="checkbox"
                    mode={'view'}
                  />
                </div>
                <div className="col-12 col-lg-3">
                  <CheckableButton
                    defaultChecked={detailWarehouseData?.CalculatedBySystem}
                    defaultValue={detailWarehouseData?.CalculatedBySystem}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    labelText={"CalculatedBySystem"}
                    inputName={"CalculatedBySystem"}
                    type="checkbox"
                    mode={'view'}
                  />
                </div>
                <div className="col-12 col-lg-3">
                  <CheckableButton
                    defaultChecked={detailWarehouseData?.PriceRegistered}
                    defaultValue={detailWarehouseData?.PriceRegistered}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    labelText={"PriceRegistered"}
                    inputName={"PriceRegistered"}
                    type="checkbox"
                    mode={mode}
                  />
                </div>
              </div>

              <>
                {mode != "view" ? (
                  <div className="col-lg-12 mt-1 btns_form">
                    <Button value="save" btnType="submit" />
                    <Button
                      btnType="cancel"
                      value="Cancel"
                      onClick={() => {
                        onHide();
                      }}
                    />
                  </div>
                ) : (
                  <div className="col-lg-12 mt-1 btns_form">
                    <Button
                      btnType="primary"
                      value="close"
                      onClick={() => onHide()}
                    />
                  </div>
                )}
              </>
            </form>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};
